import React from 'react'
import { cmsDataService, PageBase } from '../..'
import { Helmet } from 'react-helmet'

export const Meta = (props: { page: PageBase }) => {
    const { page } = props

    if (!page) return null

    const titleSeparator = ' - '
    const pageTitle = page.seoPageTitle && page.seoPageTitle.length > 0 ? page.seoPageTitle : page.name
    const title = cmsDataService.get().siteTitle + titleSeparator + pageTitle

    const url = page.seoUrl || document.location.origin + document.location.pathname

    const imageUrl = page.seoImage && page.seoImage.mobile ? document.location.origin + page.seoImage.mobile : null

    return (
        <Helmet>
            <title>{title}</title>
            <meta name="keywords" content={page.metaKeywords} />
            <meta name="description" content={page.metaDescription} />
            <meta name="copyright" content={cmsDataService.get().footer.copyrightText} />

            {/* OpenGraph data */}
            <meta property="og:title" content={title} />
            <meta property="og:description" content={page.metaDescription} />
            <meta property="og:url" content={url} />
            {imageUrl && <meta property="og:image" content={imageUrl} />}
            {imageUrl && <meta property="og:image:width" content="1200" />}
            {imageUrl && <meta property="og:image:height" content="630" />}
            {page.oGType && <meta property="og:type" content={page.oGType} />}
            {page.oGLocale && <meta property="og:locale" content={page.oGLocale} />}

            {/* Twitter data */}
            <meta name="twitter:site" content={cmsDataService.get().siteTitle} />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={page.metaDescription} />
            {page.twitterCard && <meta name="twitter:card" content={page.twitterCard} />}
            {imageUrl && <meta name="twitter:image" content={imageUrl} />}
            {/* {page.twitterCard && <meta name="twitter:creator" content={page.twitterCard} />} */}

            {/* Schema data */}
            <meta itemProp="name" content={page.name} />
            <meta itemProp="description" content={page.metaDescription} />
            {imageUrl && <meta itemProp="image" content={imageUrl} />}
        </Helmet>
    )
}
